import { combineReducers, configureStore } from '@reduxjs/toolkit';
import * as user from './Reducers/UserReducer';
import * as transaction from './Reducers/TransactionReducer';
import * as not from './Reducers/NotificationReducer';
import * as currency from './Reducers/CurrencyReducer';
import * as grp from './Reducers/GroupsReducer';
import * as grpPerm from './Reducers/GroupPermissionReducer';
import * as perm from './Reducers/PermissionsReducer';
import * as userPerm from "./Reducers/UserPermissionReducer";
import * as files from './Reducers/FileReducer';
import * as productCategory from './Reducers/CategoriesReducer';
import * as product from './Reducers/ProductReducers';
import * as stock from './Reducers/StockManagementReducers';
import * as customer from './Reducers/CustomerReducer';
import * as paymentMethod from './Reducers/PaymentMethodReducer';
import * as fee from './Reducers/FeeReducer';
import * as paynow from './Reducers/PaynowCredentialsReducer';
import * as podcast from './Reducers/PodcastReducer';
import * as order from './Reducers/OrderReducer';
import * as processingFees from './Reducers/ProcessingFeesReducer';
import * as adminAccounts from './Reducers/AdminAccountsReducer';
import * as audit from './Reducers/AuditReducer';
import * as esolutionsSmsAccount from "./Reducers/ESolutionsSmsAccountReducer";
import * as emailPackage from "./Reducers/EmailPackageReducer";
import * as smsPackage from "./Reducers/SmsPackageReducer";
import * as dashboard from './Reducers/DashboardReducer';


const rootReducer = combineReducers({
  // user reducers

  userProfile: user.ViewUserProfileReducer,
  userLogin: user.LoginReducer,
  updateProfile: user.UpdateProfileReducer,
  changePassword: user.ChangePasswordReducer,
  deleteAccount: user.DeleteAccountReducer,
  deleteAllUsers: user.deleteAllUsersReducer,
  deleteUser: user.DeleteAccountReducer,
  enableOrDisableTwoFactor: user.EnableOrDisableTwoFactorReducer,
  getAllUsers: user.GetAllUsersReducer,
  updateUser: user.UpdateUserReducer,
  resetUserPassword: user.ResetUserPasswordReducer,
  verifyAccount: user.VerifyAccountReducer,
  registerUser: user.CreateUserReducer,
  resendVerification: user.ResendVerificationReducer,
  twoFactorAuth: user.twoFactorAuthReducer,
  userAccount: user.ViewUserDetailsReducer,
  myBusiness: user.MyBusinessReducer,
  changeUserGroup: user.ChangeUserGroupReducer,
  changeUserStatus: user.changeUserStatusReducer,

  // groups
  getAllGroups: grp.GetAllGroupsReducer,
  getUnpagedGroups: grp.GetUnpagedGroupsReducer,
  getGroupById: grp.GetGroupByIdReducer,
  createGroup: grp.CreateGroupReducer,
  updateGroup: grp.UpdateGroupReducer,
  deleteGroup: grp.DeleteGroupReducer,

  // group permissions
  getGroupPermissions: grpPerm.GetGroupPermissionsReducer,
  getAllGroupPermissions: grpPerm.GetAllGroupPermissionsReducer,
  createGroupPermission: grpPerm.CreateGroupPermissionReducer,
  createBulkGroupPermissions: grpPerm.CreateBulkGroupPermissionsReducer,
  revokeGroupPermission: grpPerm.RevokeGroupPermissionReducer,
  revokeBulkGroupPermissions: grpPerm.RevokeBulkGroupPermissionsReducer,
  getUnassignedPermissions: grpPerm.GetUnassignedPermissionsReducer,

  // permissions
  getPermissions: perm.GetPermissionsReducer,
  getAllPermissions: perm.GetAllPermissionsReducer,
  getPermissionById: perm.GetPermissionByIdReducer,
  createPermission: perm.CreatePermissionReducer,
  createBulkPermissions: perm.CreateBulkPermissionsReducer,
  updatePermission: perm.UpdatePermissionReducer,
  getClientAccessiblePermissions: perm.GetClientAccessiblePermissionsReducer,
  getCustomerAccessiblePermissions: perm.GetCustomerAccessiblePermissionsReducer,
  deletePermission: perm.DeletePermissionsReducer,

  // user permissions
  userPermissions: userPerm.UserPermissionsReducer,
  allUserPermissions: userPerm.AllUserPermissionsReducer,
  assignPermission: userPerm.AssignPermissionReducer,
  assignBulkPermission: userPerm.AssignBulkPermissionReducer,
  revokePermission: userPerm.RevokePermissionReducer,
  revokeBulkPermission: userPerm.RevokeBulkPermissionReducer,
  unassignedPermissions: userPerm.UnassignedPermissionsReducer,
  unassignedClientPermissions: userPerm.UnassignedClientPermissionsReducer,

  fileUpload: files.FileUploadReducer,
  fileDelete: files.FileDeleteReducer,
  createDirectory: files.CreateDirectoryReducer,
  fileDownload: files.FileDownloadReducer,

  pagedAccounts: adminAccounts.PagedAccountsReducer,
  subscribeEmail: adminAccounts.SubscribeEmailReducer,
  subscribeSMS: adminAccounts.SubscribeSMSReducer,
  changeSmsOverdraft: adminAccounts.ChangeSmsOverdraftReducer,
  changeEmailOverdraft: adminAccounts.ChangeEmailOverdraftReducer,

  getAllAudits: audit.GetAllAuditsReducer,
  getUserAuditsByPeriod: audit.GetUserAuditsByPeriodReducer,
  getMyAuditsByPeriod: audit.GetMyAuditsByPeriodReducer,
  auditDetails: audit.AuditDetailsReducer,

  getESolutionsSmsAccount: esolutionsSmsAccount.GetESolutionsSmsAccountReducer,
  updateESolutionsSmsAccount: esolutionsSmsAccount.UpdateESolutionsSmsAccountReducer,

  createEmailPackage: emailPackage.CreateEmailPackageReducer,
  updateEmailPackage: emailPackage.UpdateEmailPackageReducer,
  deleteEmailPackage: emailPackage.DeleteEmailPackageReducer,
  getPagedEmailPackages: emailPackage.GetPagedEmailPackagesReducer,

  createSmsPackage: smsPackage.CreateSmsPackageReducer,
  updateSmsPackage: smsPackage.UpdateSmsPackageReducer,
  deleteSmsPackage: smsPackage.DeleteSmsPackageReducer,
  getPagedSmsPackages: smsPackage.GetPagedSmsPackagesReducer,
  getAllSmsPackages: smsPackage.GetAllSmsPackagesReducer,











  // categories
  allProductCategories: productCategory.GetAllProductCategoriesReducer,
  pagedProductCategories: productCategory.GetPagedProductCategoriesReducer,
  productCategoryDetails: productCategory.ProductCategoryDetailsReducer,
  createProductCategory: productCategory.CreateProductCategoryReducer,
  updateProductCategory: productCategory.UpdateProductCategoryReducer,
  deleteProductCategory: productCategory.DeleteProductCategoryReducer,

  // Products
  getPagedProducts: product.GetPagedProductsReducer,
  allProducts: product.GetAllProductsReducer,
  productDetails: product.ProductDetailsReducer,
  createProduct: product.CreateProductReducer,
  updateProduct: product.UpdateProductReducer,
  deleteProduct: product.DeleteProductReducer,
  updateProductPricing: product.UpdateProductPricingReducer,

  // images
  productImages: product.ProductImagesReducer,
  createProductImage: product.CreateProductImageReducer,
  updateProductImage: product.UpdateProductImageReducer,
  deleteProductImage: product.DeleteProductImageReducer,

  // variants
  productVariants: product.ProductVariantsReducer,
  createProductVariant: product.CreateProductVariantReducer,
  updateProductVariant: product.UpdateProductVariantReducer,
  deleteProductVariant: product.DeleteProductVariantReducer,

  // pricing rules
  productPricingRules: product.ProductPricingRulesReducer,
  createProductPricingRule: product.CreateProductPricingRuleReducer,
  updateProductPricingRule: product.UpdateProductPricingRuleReducer,
  deleteProductPricingRule: product.DeleteProductPricingRuleReducer,

  // stock management
  stockOverview: stock.StockOverviewReducer,
  stockSummary: stock.StockSummaryReducer,
  updateProductStock: stock.UpdateStockReducer,
  refreshStockStatuses: stock.RefreshStockStatusesReducer,



  //transactions
  getAllTransactions: transaction.GetAllTransactionsReducer,
  transactionDetails: transaction.TransactionDetailsReducer,
  searchTransactions: transaction.SearchTransactionsReducer,
  transactionsByPeriod: transaction.TransactionsByPeriodReducer,
  transactionsByPeriodAndStatus: transaction.TransactionsByPeriodAndStatusReducer,
  transactionsDashboardMetrics: transaction.TransactionsDashboardMetricsReducer,
  exportTransactions: transaction.ExportTransactionsReducer,
  generateReportByStatus: transaction.GenerateReportByStatusReducer,
  generateReportByTimePeriod: transaction.GenerateReportByTimePeriodReducer,

  //notifications
  readNotification: not.readNotificationReducer,
  readAllNotifications: not.readAllNotificationsReducer,
  getNotification: not.getNotificationReducer,
  notificationsList: not.NotificationsListReducer,
  deleteNotification: not.DeleteNotificationReducer,
  deleteAllNotifications: not.DeleteAllNotificationReducer,

  allCurrencies: currency.GetAllCurrenciesReducer,
  pagedCurrencies: currency.GetCurrenciesPagedReducer,
  currencyDetails: currency.CurrencyDetailsReducer,
  createCurrency: currency.CreateCurrencyReducer,
  updateCurrency: currency.UpdateCurrencyReducer,
  deleteCurrency: currency.DeleteCurrencyReducer,

  customersList: customer.GetAllCustomersReducer,
  customerDetails: customer.GetCustomerDetailsReducer,
  createCustomer: customer.CreateCustomerReducer,
  updateCustomer: customer.UpdateCustomerReducer,

  paymentMethods: paymentMethod.GetAllPaymentMethodsReducer,
  paymentMethodCodes: paymentMethod.GetPaymentMethodCodesReducer,
  pagedPaymentMethods: paymentMethod.GetPagedPaymentMethodsReducer,
  paymentMethodDetails: paymentMethod.PaymentMethodDetailsReducer,
  createPaymentMethod: paymentMethod.CreatePaymentMethodReducer,
  updatePaymentMethod: paymentMethod.UpdatePaymentMethodReducer,
  deletePaymentMethod: paymentMethod.DeletePaymentMethodReducer,

  fees: fee.GetAllFeesReducer,
  pagedFees: fee.GetPagedFeesReducer,
  feeDetails: fee.FeeDetailsReducer,
  createFee: fee.CreateFeeReducer,
  updateFee: fee.UpdateFeeReducer,
  deleteFee: fee.DeleteFeeReducer,

  paynowCredentialsPaged: paynow.GetPagedPaynowCredentialsReducer,
  createPaynowCredential: paynow.CreatePaynowCredentialReducer,
  updatePaynowCredential: paynow.UpdatePaynowCredentialReducer,
  deletePaynowCredential: paynow.DeletePaynowCredentialReducer,

  // podcasts
  getAllPodcasts: podcast.GetAllPodcastsReducer,
  podcastDetails: podcast.PodcastDetailsReducer,
  createPodcast: podcast.CreatePodcastReducer,
  updatePodcast: podcast.UpdatePodcastReducer,
  deletePodcast: podcast.DeletePodcastReducer,
  podcastStats: podcast.GetPodcastStatsReducer,

  // Orders
  getAllOrders: order.GetAllOrdersReducer,
  orderDetails: order.OrderDetailsReducer,
  orderItems: order.OrderItemsReducer,
  orderStats: order.OrderStatsReducer,
  completeOrder: order.CompleteOrderReducer,
  userOrders: order.UserOrdersReducer,

  // Processing Fees
  getAllProcessingFees: processingFees.GetAllProcessingFeesReducer,
  orderProcessingFees: processingFees.OrderProcessingFeesReducer,

  // Dashboard metrics
  dashboardMetrics: dashboard.DashboardMetricsReducer,
  dashboardUserMetrics: dashboard.DashboardUserMetricsReducer,
  dashboardEmailMetrics: dashboard.DashboardEmailMetricsReducer,
  dashboardSmsMetrics: dashboard.DashboardSmsMetricsReducer,
  dashboardRevenueMetrics: dashboard.DashboardRevenueMetricsReducer,
  dashboardPerformanceMetrics: dashboard.DashboardPerformanceMetricsReducer,

});




// get userInfo from localStorage
const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;


const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});
